import React, { useState, useEffect } from "react";
import { Applogo } from "../../../Routes/ImagePath";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Api_Url } from "../../../config/config";

const ChangePassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const navigate = useNavigate();

  console.log("object",email)
  console.log("object",token)

  useEffect(() => {
    
    const user = sessionStorage.getItem("user");
    const userData = JSON.parse(user)
    console.log(userData)
    if (user) {
      const userObject = JSON.parse(user);
      setEmail(userObject.email);
      setToken(userObject.accessToken); 
    }
  }, []);

  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const data = { email, password, confirmPassword, token };
      const response = await axios.post(`${Api_Url}api/Account/reset-password`, data, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the request headers
        },
      });
      console.log("response", response);

      if (response.status === 200) {
        navigate('/');
      } else {
        alert("Password reset failed");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          {/* Account Logo */}
          <div className="account-logo">
            <Link to="/admin-dashboard">
              <img src={Applogo} alt="Roha housing" />
            </Link>
          </div>
          <div className="account-box">
            <div className="account-wrapper">
              <h3 className="account-title">Change Password</h3>
              <form>
                <div className="input-block mb-3">
                  <label className="col-form-label">New Password</label>
                  <input 
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-control" 
                  />
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">Confirm Password</label>
                  <input 
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="form-control" 
                  />
                </div>
                <div className="submit-section mb-4">
                  <button
                    type="button"
                    className="btn btn-primary submit-btn"
                    onClick={handleSubmit}
                  >
                    Update Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
